export enum StorageType {
  AmazonS3 = 'AmazonS3',
  AmazonS3UnifiedBilling = 'AmazonS3UnifiedBilling',
  Azure = 'Azure',
  AzureStack = 'AzureStack',
  BackBlaze = 'BackBlaze',
  Minio = 'Minio',
  S3Compatible = 'S3Compatible',
  Swift = 'Swift',
  Wasabi = 'Wasabi',
  WasabiUnifiedBilling = 'WasabiUnifiedBilling'
}
